import { createMuiTheme } from '@material-ui/core/styles';
const grouponHeadingColor = '#75787B';
const grouponBlack = '#333333';
const customTheme = {
    grouponBlack,
    grouponHeadingColor,
    palette: {
        action: {
            active: '#53a318',
            disabled: '#abf189fa'
        },
        primary: {
            main: '#53a318',
            dark: '#367806',
            light: '#4da700'
        },
        secondary: {
            main: '#f6f7f8',
            light: '#979797',
            dark: '#676767'
        }
    },
    typography: {
        fontFamily: [
            'Open Sans',
            'sans-serif'
        ].join(',')
    },
    overrides: {
        MuiRadio: {
            checked: {
                color: '#53a318 !important'
            }
        },
        MuiPickersDay: {
            day: {
                color: grouponHeadingColor,
                width: '36px',
                borderRadius: '4px',
                // maxWidth: '36px',
                margin: '0px 7px',
                '&:hover': {
                    color: '#fff',
                    backgroundColor: '#53a318',
                  }
            },
            disabled: {
                color: '#E6E7E8',
                fontWeight: 600
            },
            selected: {
                borderRadius: '4px'
            }
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                width: '14%',
                margin: '0px',
                // maxWidth: '36px',
                textAlign: null,
                color: grouponBlack,
                fontWeight: 'bold'
            },
            daysHeader: {
                width: '100%',
                marginLeft: '22px'
            },
            switchHeader: {
                color: '#53a318'
            }
        },
        MuiPickersCalendar: {
            week: {
                width: '100%',
                '& div': {
                    width: '14%'
                }
            }
        }
    }

}
const appTheme = createMuiTheme(customTheme);

export default appTheme;



// WEBPACK FOOTER //
// ./src/containers/App/theme.js